/**
 * Baja el archivo del reporte con un anchor oculto. Es el mismo bloque que
 * tenían las tres descargas, una por acción.
 */
export const downloadFromUrl = (url: string): void => {
  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const downloadUrl = URL.createObjectURL(xhttp.response);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.display = "none";
      a.href = downloadUrl;
      a.download = "";
      a.click();
    }
  };

  xhttp.open("GET", url, true);
  xhttp.responseType = "blob";
  xhttp.send();
};
